import React from "react";
import { FormControl, InputLabel, Select, MenuItem, OutlinedInput, FormHelperText } from "@mui/material";

const GenericDropDown = ({
  label,
  value,
  onChange,
  options = [],
  required = false,
  error = false,
  helperText = "",
  name,
  sx = {},
  inputProps = {},
  MenuProps = {},
  renderValue,
  ...props
}) => (
  <FormControl
    fullWidth
    margin="dense"
    size="small"
    required={required}
    error={error}
    sx={{
        backgroundColor: "white",
      "& .MuiFormLabel-asterisk": { color: "red" },
      ...sx,
    }}
  >
    {label && (
      <InputLabel id={`${name || label}-label`}>
        {label}
      </InputLabel>
    )}
    <Select
      labelId={`${name || label}-label`}
      name={name}
      value={value}
      onChange={onChange}
      input={<OutlinedInput label={label} />}
      renderValue={renderValue}
      MenuProps={MenuProps}
      {...props}
    >
      {options.map((option) =>
        typeof option === "string" ? (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ) : (
          <MenuItem key={option.value} value={option.value}>
            {option.label || option.value}
          </MenuItem>
        )
      )}
    </Select>
    {helperText && <FormHelperText>{helperText}</FormHelperText>}
  </FormControl>
);

export default GenericDropDown;